$(document).ready(function () {
    // Alert messages are now displayed with Toastr.js
    if ($('.toast-it').length) {
        var $alert = $('.toast-it'),
            content = $alert.text();

        $alert.remove();

        // General options for both cases
        toastr.options = {
            "progressBar": true
        };

        if ($alert.hasClass('alert-danger')) {
            toastr.options.timeOut = 45000;
            toastr.options.extendedTimeOut = 20000;
            toastr.error(content);
        } else {
            toastr.options.timeOut = 3000;
            toastr.success(content);
        }
    }
});
